export default __webpack_public_path__ + "static/media/zoomIn.2b22864d.svg";